<template>
  <div class="row justify-content-between pt-6">
    <div class="d-flex align-items-center col-lg-6 order-1 order-lg-0">
      <span class="table-quantity-counter mr-5">
        Total: {{ pagination.count }}
      </span>
      <button class="btn p-0 table-refresh" @click="$emit('dispatch')">
        <i class="fa-solid fa-refresh" />
      </button>
    </div>
    <div class="col-lg-6 d-flex align-items-center justify-content-end">
      <snow-search 
        v-if="search"
        v-model="searchQuery"
        @search="search => $emit('searching', search)"
      />

      <div class="d-none d-lg-flex ml-3">
        <bp-tooltip :text="disabled_tooltip_msg">
          <button
            class="btn btn-primary btn-primary px-5 btn-40"
            @click="$emit('add')"
            :disabled="disableAdd"
          >
            <i class="fa-solid fa-plus mr-6" />
            Adicionar
          </button>
        </bp-tooltip>
      </div>
    </div>

    <div class="col-12 d-lg-none my-6">
      <bp-tooltip :text="disabled_tooltip_msg">
        <button
          class="btn btn-primary btn-primary btn-block btn-40"
          @click="$emit('add')"
          :disabled="disableAdd"
        >
          <i class="fa-solid fa-plus mr-6" />
          Adicionar
        </button>
      </bp-tooltip>
    </div>
  </div>
</template>
<script>
import { BpTooltip } from "@/components/designSystem/";
import { mapState } from "vuex";
export default {
  components: { BpTooltip },
  props: {
    search: {
      type: Boolean,
      default: true
    },
    disableAdd: {
      type: Boolean,
      default: false
    },
    disabled_tooltip_msg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      searchQuery: ""
    }
  },
  computed: {
    ...mapState("integration", ["pagination"])
  }
};
</script>
